<img
  *ngIf="imageUrl && !useBackgroundImage"
  [src]="imageUrl"
  [alt]="altText"
  class="item-image"
  [class.item-image-small]="size === 'small'"
  [class.item-image-compact]="size === 'compact'"
  [class.item-image-medium]="size === 'medium'"
  [class.item-image-large]="size === 'large'"
  [class.item-image-large-portrait]="size === 'large-portrait'"
  [class.item-image-extra-large]="size === 'extra-large'"
/>

<div
  *ngIf="useBackgroundImage || !imageUrl"
  class="item-image"
  [class.item-image-small]="size === 'small'"
  [class.item-image-compact]="size === 'compact'"
  [class.item-image-medium]="size === 'medium'"
  [class.item-image-large]="size === 'large'"
  [class.item-image-large-portrait]="size === 'large-portrait'"
  [class.item-image-extra-large]="size === 'extra-large'"
  [style.background-image]="imageUrl"
></div>
